export function resolveDashboardLogo(branding?: {
  dashboard_logo_height?: number | null;
  dashboard_logo_padding?: number | null;
} | null) {
  const bound = (value: number | null | undefined, fallback: number, min: number, max: number) =>
    typeof value === "number" && Number.isFinite(value)
      ? Math.min(max, Math.max(min, Math.round(value)))
      : fallback;
  return {
    height: bound(branding?.dashboard_logo_height, 32, 24, 64),
    padding: bound(branding?.dashboard_logo_padding, 8, 0, 24),
  };
}